import { Button } from '@/components/ui/button';
import { InputGroup, InputGroupAddon, InputGroupInput } from '@/components/ui/input-group';
import { useLookupNumberPlate } from '@/hooks/use-lookup-number-plate';
import { ArrowRight, MagnifyingGlassSL } from '@tac/icons';
import { useCallback, useId, useState } from 'react';

const RegoSearchBox = () => {
  const [numberPlate, setNumberPlate] = useState('');
  const inputId = useId();

  const { numberPlateNotFound, immediateSubmit, cancelSearch, submittingNumberPlate, regoError, clearRegoSearchError } =
    useLookupNumberPlate();

  const isLoading = submittingNumberPlate && numberPlate.length > 0;

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (isLoading) {
      return;
    }
    immediateSubmit(numberPlate);
  };

  const handleInputChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      if (isLoading) {
        return;
      }

      clearRegoSearchError();

      const input = e.target.value;
      const filteredInput = input.toUpperCase();

      if (input.length > 6) return;

      setNumberPlate(filteredInput);

      if (!filteredInput.trim()) {
        cancelSearch();
        return;
      }
    },
    [setNumberPlate]
  );

  return (
    <form className="w-full" onSubmit={handleSubmit}>
      <div className="flex w-full gap-3">
        <InputGroup>
          <InputGroupAddon>
            <MagnifyingGlassSL name="Search" className="size-5" />
          </InputGroupAddon>
          <InputGroupInput
            placeholder="ABC123"
            disabled={isLoading}
            onChange={handleInputChange}
            value={numberPlate}
            type="text"
            aria-describedby={numberPlateNotFound ? `${inputId}-error` : undefined}
          />
        </InputGroup>
        <Button type="submit" variant="primary" size="default" disabled={numberPlate.length < 1 || isLoading}>
          <span className="hidden md:block">Search</span>
          <ArrowRight className="size-5 md:hidden" />
        </Button>
      </div>
      {regoError && (
        <div id={`${inputId}-error`} className="block text-sm mt-2 text-red-500" role="alert">
          {regoError}
        </div>
      )}
    </form>
  );
};

export default RegoSearchBox;
